import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog"
import { LeadForm } from "@/components/lead-form"
import { SetStateAction } from "react";
type QuoteModal={
    quoteModalOpen:boolean
    setQuoteModalOpen: (value: SetStateAction<boolean>) => void
}

const QuoteModal = ({quoteModalOpen,setQuoteModalOpen}:QuoteModal) => {
    return (
        <Dialog open={quoteModalOpen} onOpenChange={setQuoteModalOpen}>
            <DialogContent className="w-[95vw] max-w-3xl sm:max-w-3xl max-h-[90vh] overflow-y-auto p-0">
                <DialogHeader className="px-6 sm:px-8 pt-6 pb-4 border-b border-slate-200 bg-gradient-to-r from-blue-50 to-orange-50">
                    <DialogTitle className="text-2xl sm:text-3xl font-bold text-foreground">
                        Get Your Free Quote
                    </DialogTitle>
                    <DialogDescription className="text-muted-foreground text-base">
                        Fill out the form below and we'll get back to you within 1 hour with a personalized quote
                    </DialogDescription>
                </DialogHeader>
                <div className="px-6 sm:px-8 py-6 sm:py-8">
                    <LeadForm inModal={true} />
                </div>
            </DialogContent>
        </Dialog>
    )
};
export default QuoteModal;